<script setup lang="ts">
import { ref } from "vue";
import privacyHtml from "../public/privacy.html?raw";
import termsHtml from "../public/terms.html?raw";

const legalDialog = ref<HTMLDialogElement>();
const legalText = ref("");
// These are bundled, owned static notices. Kiosk dialogs omit navigation links.
function showLegal(kind: "privacy" | "terms") {
  const html = kind === "privacy" ? privacyHtml : termsHtml;
  legalText.value = (/<main>([\s\S]*?)<\/main>/.exec(html)?.[1] ?? "").replace(
    /<\/?a\b[^>]*>/g,
    "",
  );
  legalDialog.value?.showModal();
}

// Shell only: every view owns its own layout, because a kiosk display and a phone
// share no chrome.
</script>

<template>
  <!--
    One `main` landmark for the whole app. Screen-reader users navigate by landmark and
    "skip to main content" depends on it; without one, every route makes them tab through
    the ticker tape to reach the board.
  -->
  <main>
    <RouterView />
    <nav
      v-if="!$route.path.startsWith('/display/')"
      aria-label="Legal"
      style="display: flex; gap: 1rem; justify-content: center; padding: 1rem; font-size: 0.8rem"
    >
      <template v-if="$route.path.startsWith('/order/')">
        <button type="button" @click="showLegal('privacy')">Privacy</button>
        <button type="button" @click="showLegal('terms')">Terms</button>
      </template>
      <template v-else><a href="/privacy.html">Privacy</a><a href="/terms.html">Terms</a></template>
    </nav>
    <dialog ref="legalDialog" aria-label="Legal notice" class="legal-dialog">
      <button type="button" autofocus @click="legalDialog?.close()">Close notice</button>
      <!-- Bundled static HTML only, never reader or server-supplied content. -->
      <!-- eslint-disable-next-line vue/no-v-html -->
      <article v-html="legalText" />
    </dialog>
  </main>
</template>

<style scoped>
.legal-dialog {
  color-scheme: light dark;
  max-width: 46rem;
  width: calc(100% - 2rem);
  max-height: 85dvh;
  padding: 1.5rem;
  border-radius: 0.75rem;
  line-height: 1.7;
}
.legal-dialog::backdrop {
  background: #0008;
}
</style>
